"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.LoadMoreProgress = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var LoadMoreProgress = function LoadMoreProgress(_ref) {
  var loaded = _ref.loaded,
    total = _ref.total;
  if (!loaded || !total) {
    return null;
  }
  var width = "".concat(loaded / total * 100, "%");
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'text-center margin-bottom-3'
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: 'text-medium'
  }, loaded), /*#__PURE__*/_react["default"].createElement("span", {
    className: 'margin-left-5 margin-right-5'
  }, '/'), /*#__PURE__*/_react["default"].createElement("span", {
    className: 'text-medium'
  }, total)), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'progress bg-white height-2 margin-bottom-10'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'progress-bar',
    style: {
      width: width
    }
  })));
};
exports.LoadMoreProgress = LoadMoreProgress;
LoadMoreProgress.defaultProps = {
  loaded: 0,
  total: 0
};
LoadMoreProgress.propTypes = {
  loaded: _propTypes["default"].number,
  total: _propTypes["default"].number
};
var _default = LoadMoreProgress;
exports["default"] = _default;